/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { Review } from './Review'
import { ReviewFromJSON, ReviewFromJSONTyped, ReviewToJSON } from './Review'

/**
 *
 * @export
 * @interface PaginatedReviewPublic
 */
export interface PaginatedReviewPublic {
  /**
   *
   * @type {Array<Review>}
   * @memberof PaginatedReviewPublic
   */
  results: Array<Review>
  /**
   *
   * @type {number}
   * @memberof PaginatedReviewPublic
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedReviewPublic
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedReviewPublic
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedReviewPublic interface.
 */
export function instanceOfPaginatedReviewPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedReviewPublicFromJSON(json: any): PaginatedReviewPublic {
  return PaginatedReviewPublicFromJSONTyped(json, false)
}

export function PaginatedReviewPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedReviewPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(ReviewFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedReviewPublicToJSON(value?: PaginatedReviewPublic | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(ReviewToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
